import React from "react";
import { Alert } from 'antd'
import styles from './quotation.module.scss'
const QuotationReplied = () => {
    return <div className={styles.container}>
        <h3>Task For You</h3>
        <Alert type='info' message="Quoatation replied" description='You have replied to the quotation, wait for the customer approval'  />
    </div>
}
export default QuotationReplied